<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="110px" class="demo-ruleForm">
          <el-form-item label="配送模板名称：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入配送模板名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="toBannerAdd" size="small" type="primary" class="bg-theme">添加配送模板</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="templateName"
            label="配送模板名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="shipMethod"
            label="配送方式">
            <template slot-scope="scope">
              <span>{{scope.row.shipMethod == 1 ? '包邮' : '不包邮'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBannerBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBannerBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!--    添加运费模版弹窗-->
        <el-drawer
          size="960px"
          title="运费模板"
          :visible.sync="moveDrawer">
          <el-form ref="moveForm" :model="moveForm" :rules="rules" label-width="140px">
            <el-form-item label="模版名称：">
              <el-input style="width: 424px;" v-model="moveForm.templateName" placeholder="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item label="包邮方式：">
              <el-radio-group v-model="moveForm.shipMethod">
                <el-radio :label="1">包邮</el-radio>
                <el-radio :label="2">部分包邮</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="moveForm.shipMethod == 2" label="计费方式：">
              <el-radio-group v-model="moveForm.chargeMethod">
                <el-radio :label="1">按件数</el-radio>
                <el-radio :label="2">按重量</el-radio>
                <el-radio :label="3">按体积</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="moveForm.shipMethod == 2" label="运费：">
              <el-table
                :data="moveForm.goodsMoveTemplateChargeSaveDtoList"
                border
                style="width: 100%">
                <el-table-column
                  prop="chargeType"
                  label="送达到"
                  width="180">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.areaIdList" multiple placeholder="请选择">
                      <el-option
                        v-for="item in areaList"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="firstArticle"
                  :label="moveForm.chargeMethod == 1 ? '首件' : moveForm.chargeMethod ==  2 ? '首重量(KG)' : '首件体积(m³)'"
                  width="130">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.firstArticle" style="width: 96px;" controls-position="right" :min="1" :max="10"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="firstMoveMoney"
                  label="运费(元)">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.firstMoveMoney" style="width: 96px;" controls-position="right" :min="1" :max="10"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="continueArticle"
                  :label="moveForm.chargeMethod == 1 ? '续件' : moveForm.chargeMethod ==  2 ? '续重量(KG)' : '续件体积(m³)'"
                  width="120">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.continueArticle" style="width: 96px;" controls-position="right" :min="1" :max="10"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="continueMoveMoney"
                  label="续费(元)">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.continueMoveMoney" style="width: 96px;" controls-position="right" :min="1" :max="10"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="80">
                  <template slot-scope="scope">
                    <el-button @click="delTableBtn(scope.$index)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="primary" style="margin-top: 24px;" @click="addTableBtn">添加区域</el-button>
            </el-form-item>
            <el-form-item v-if="moveForm.shipMethod == 2" label="包邮区域：">
              <el-select style="width: 424px;" v-model="areaChooseList" multiple placeholder="请选择">
                <el-option
                  v-for="item in areaList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序 ：">
              <el-input style="width: 424px;" v-model="moveForm.sort" placeholder="请输入排序，默认1"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="moveOffBtn">取消</el-button>
              <el-button @click="moveSureBtn" type="primary" size="medium">确定</el-button>
            </el-form-item>
          </el-form>
        </el-drawer>
  </div>
</template>

<script>
import { deliveryList, deliveryDel, deliveryInfo, deliveryAdd, deliveryEdit } from '@/api/setting'
import { queryAllGoodsMoveTemplateList, queryAreaTreeList } from '@/api/goods'
export default {
  name: 'Pickup',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoId:'',
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      moveData:[],
      moveDrawer: false,
      moveForm:{
        templateName: '',
        shipMethod:1,
        chargeMethod:1,
        sort:'',
        goodsMoveTemplateChargeSaveDtoList:[{
          chargeType:0,
          areaIdList:[],
          firstArticle:'',
          firstMoveMoney:'',
          continueMoveMoney:'',
          continueArticle:''
        }]
      },
      areaList:[],
      areaChooseList:[],
      rules: {
        categoryTreePageVoList: [
          { required: true }
        ],
        thumb: [
          { required: true }
        ],
        goodsPicturePageVoList: [
          { required: true }
        ],
        templateName: [
          { required: true }
        ]
      }
    }
  },
  mounted () {
    this.moveDataFun();
    this.getInfoList()
  },
  methods: {
    /* 获取运费模版数据和省市区数据 */
    moveDataFun(){
      var that = this;
      queryAllGoodsMoveTemplateList().then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.moveData = data;
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      });
      queryAreaTreeList().then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.areaList = data;
        }
      });
    },
    /* 运费模版table添加一行 */
    addTableBtn(){
      var singleValue = {
        chargeType:0,
        areaIdList:[],
        firstArticle:'',
        firstMoveMoney:'',
        continueMoveMoney:'',
        continueArticle:''
      }
      this.moveForm.goodsMoveTemplateChargeSaveDtoList.push(singleValue);
    },
    /* 运费模版table删除一行 */
    delTableBtn(index){
      this.moveForm.goodsMoveTemplateChargeSaveDtoList.splice(index,1);
    },
    /* 运费模版取消添加操作 */
    moveOffBtn(){
      this.moveDrawer = false;
    },
    /* 运费模版确认添加操作 */
    moveSureBtn(){
      var that = this;
      var infoId = that.infoId;
      var moveForm = that.moveForm;
      var areaChooseList = that.areaChooseList;
      var passData = moveForm;
      passData.areaIdList = areaChooseList;
      if(infoId == ''){
        // 新增
        deliveryAdd(passData).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.moveDrawer = false;
                that.getInfoList();
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }else{
        // 编辑
        passData.id = infoId;
        deliveryEdit(passData).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.moveDrawer = false;
                that.getInfoList();
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      deliveryList({ templateName: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 轮播图-编辑 */
    editBannerBtn (infoId) {
      this.infoId = infoId;
      var that = this;
      deliveryInfo({ id: infoId}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            var data = res.data;
            that.moveForm = data;
            that.moveForm.goodsMoveTemplateChargeSaveDtoList = data.goodsMoveTemplateChargePageVoList;
            var areaChooseList = [];
            data.goodsMoveTemplateChargeAreaPageVoList.forEach(function(item){
              areaChooseList.push(item.id);
            });
            that.areaChooseList = areaChooseList;
            that.moveDrawer = true;
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 轮播图-删除 */
    delBannerBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        deliveryDel({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 跳转添加轮播图 */
    toBannerAdd () {
      this.infoId = '';
      this.moveForm.templateName = '';
      this.moveForm.shipMethod = 1;
      this.moveForm.chargeMethod = 1;
      this.moveForm.sort = '';
      this.moveForm.goodsMoveTemplateChargeSaveDtoList = [{
        chargeType:0,
        areaIdList:[],
        firstArticle:'',
        firstMoveMoney:'',
        continueMoveMoney:'',
        continueArticle:''
      }];
      this.areaChooseList =[];
      this.moveDrawer = true;
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/Delivery.vue